import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { rootRoute } from 'root/RootLayout';

export const aboutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'about',
  component: lazyRouteComponent(() => import('./AboutView')),
});
